export class CONAPartnerFunctionPayloadRequest {
    RequestID: number;
    PartnerType: string;
}

export default CONAPartnerFunctionPayloadRequest;